export enum OverrideListType {
  PERMIT = "permit",
  DENY = "deny",
}
